import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';
import { FacultyNamePopupComponent } from '../training-calendor/faculty-name-popup/faculty-name-popup.component';
@Component({
  selector: 'app-program-attendance',
  templateUrl: './program-attendance.component.html',
  styleUrls: ['./program-attendance.component.scss'],
})
export class ProgramAttendanceComponent  implements OnInit {
  searchTerm:any;
   programForm!: FormGroup;
   subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedYearForCompetency: any = null;
    pmsYears: any = [];
    buttonColorName: any;
  getProgrammeForAttendance: any;
  loggedInUserName: any;
   constructor(private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService,) { 
      this.programForm = this.fb.group({
        selectedProgram: [''] // Default empty selection
      });
    }
 
  
  ngOnInit() {

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    console.log('loggedInUserCompanyID Value:', this.loggedInUserCompanyID); // Debugging

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this. getpmsyearlist();
    // this.programForm = this.fb.group({
    //   selectedProgram: new FormControl(null),
    // });
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      
      this.setSelectedYear(yearValue);

    });
  }
  
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
          this.selectedYearForCompetency = selectedYearObj?.year;
         
          let test = selectedYearObj?.year.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
       this.getAllProgrammeForAttendance();
          [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  getYearSetupForReimbursement(year: any) {
    this.selectedYearForCompetency = year;
console.log(   this.selectedYearForCompetency);

    this.selectedYear = year;
    // console.log(this.selectedYear)
   
  }
  
    
//  ----------------------------------Start Calendar -----------------------------------------------------------------------
programList: string[] = ['Absent', 'Present']; 
programType: string[] = ['Program 1', 'Program 2']; 



// ---------------------------------- Attedance div ----------------------------------------------------------------------

attendanceList = [
  {  present: 60, absent: 20 },

];


getAttendancePercentage(present: number, absent: number): number {
  const total = present + absent;
  return total ? Math.round((present / total) * 100) : 0;
}




// ----------------------------------------- headings ------------------------------------------------------------------------------

tableHeaders = [
  { label: 'Training Type', key: 'trainingType' },
  { label: 'Programme Title', key: 'title' },
  { label: 'Programme Code', key: 'code' },
  { label: 'LMS Link', key: 'lmsLink' },
  { label: 'Location', key: 'location' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endDate' },
  { label: 'Start Time', key: 'endDate' },
  { label: 'End Time', key: 'endDate' },
  { label: 'Functional/Behavioral', key: 'category' },
  { label: 'Dept.', key: 'department' },
  { label: 'Band', key: 'band' },
  { label: 'Grade', key: 'grade' },
  { label: 'No. of Program Days', key: 'programDays' },
  { label: 'Budget Cost', key: 'budgetCost' },
  { label: 'Actual Cost', key: 'actualCost' },
  { label: 'Faculty name', key: 'facultyname' },
  { label: 'Objective', key: 'objective' },

];


 // --------------------------------------Employee Training Program Table ------------------------------------------------------

 employeeTableHeaders = [
  { label: 'Emp Code' },
  { label: 'Emp Name' },
  { label: 'Department' },
  { label: 'Band' },
  { label: 'Grade' },
  { label: 'Status' }
];



employeeTrainingPrograms = [
  { code: 'B001', name: 'Ram', department: 'Sales', band: 'A', grade: 'Junior', nominatedBy: 'Narayan', status: 'absent', selected: false },
  { code: 'B002', name: 'Laksham', department: 'Marketing', band: 'B', grade: 'Manager', nominatedBy: 'Tim', status: 'present', selected: false }
];


// -------------------------------------------------- Select/Deselect Checkboxes ---------------------------------
isAnySelected: boolean = false;

selectAll(event: any) {
  const isChecked = event.checked;
  this.employeeTrainingPrograms .forEach(program => program.selected = isChecked);
  this.updateSelectionStatus();
}

updateSelectionStatus() {
  this.isAnySelected = this.employeeTrainingPrograms.some(program => program.selected);
}


//  ----------------------------------------------- Status for Present Absent checkboxes -----------------------------------

presentSelected(){

}


absentSelected(){
  
}
//  -------------------------------------------  Faculty Details Popup-------------------------------------------------------

facultyNamePopup()
{
     const dialogConfig = new MatDialogConfig();
            dialogConfig.height = '70%';
            dialogConfig.width = '70%';
            dialogConfig.data = {};
            dialogConfig.panelClass = 'custom-dialog-container';
            const dialogRef = this.dialog.open(FacultyNamePopupComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(result => {
              
            });
}


// -------------------------------------- Program Attendance Table for Training Program ----------------------------------------------------------------

getAllProgrammeForAttendance(){
  let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
      this.httpService.callGetService(this.config.getAllProgram + fiscal_year+"/"+year+"/"+companyId).subscribe((result: any) => {
       this.getProgrammeForAttendance = result.data;
       console.log("Get All Programmmes====", this.getProgrammeForAttendance);
       
        })     
}



  
// ====================================== Filters ======================================================================

filterEmployees() {
  // this.employees = this.filteredEmployees.filter((emp: any) =>
  //   emp?.firstName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.lastName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.salutation?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.status?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //   emp?.candidateEmail?.toLowerCase().includes(this.searchTerm.toLowerCase())  // Adjust keys based on API response
  // );
  // console.log(this.employees);

}

// ============================ Show records ==============================
DislaySelectedRecord(event: any) {
  // this.employees = this.filteredEmployees.slice(0, event.value);
}

// ========================== Download List ==================================

downloadEmployeeList() {
  // if (!this.employees || this.employees.length === 0) {
  //   console.warn('No data available for export');
  //   return;
  // }

  // // Extract only the required fields
  // const filteredData = this.employees.map((employee: any) => ({
  //   Salutation: employee.salutation,
  //   FirstName: employee.firstName,
  //   LastName: employee.lastName,
  //   "Personal Email Id": employee.candidateEmail, // Fixed key with quotes
  //   Status: this.formatedataVariable(employee.status)
  // }));

  // // Convert to Excel format
  // const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
  // const workbook: XLSX.WorkBook = { Sheets: { 'Employees': worksheet }, SheetNames: ['Employees'] };
  // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  // // Convert to Blob and trigger download
  // const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  // FileSaver.saveAs(data, 'Employee_List.xlsx');
}

}
